// extracted by mini-css-extract-plugin
export default {"card":"Card_Shop_card__NfJtO"};